module.exports = __webpack_public_path__ + "static/media/tipos-cookies-2.caada3c9.png";